import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { CurrentUserHttpClient } from './current-user-http-client';
import { CurrentUserEntityActions } from './current-user.store';

@Injectable({ providedIn: 'root' })
export class CurrentUserEffects {
  private readonly currentUserService = inject(CurrentUserHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(CurrentUserEntityActions, this.actions$);

  public fetchCurrentUser$ = this.effects(CurrentUserEntityActions.fetch, () =>
    this.currentUserService.loadCurrentUser(),
  );

  public updateCurrentAdmin$ = this.effects(CurrentUserEntityActions.update, ({ payload }) =>
    this.currentUserService.updateCurrentUser(payload),
  );

  public updatePassword$ = this.effects(CurrentUserEntityActions.updatePassword, ({ payload }) =>
    this.currentUserService.updatePassword(payload).pipe(
      map(admin => CurrentUserEntityActions.updatePasswordSuccess({ payload: admin })),
      catchError(error => of(CurrentUserEntityActions.updatePasswordFailed({ payload: error }))),
    ),
  );
}
